<div class="popup">
    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <img src="../../../../../assets/icones/quotations.svg" alt="">
            </div>
            <h1 class="header-title">{{ 'quotations_and_orders.copilot_score.kill_stock_details.title' | translate }} {{data.quote_name}} </h1>
        </div>
        <button class="close-btn" (click)="close()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <div class="conflicting-products">
        <span class="conflicting-products-title">{{ 'quotations_and_orders.copilot_score.kill_stock_details.conflicting_products' | translate }}</span>
        <span class="blue-text">{{data.score.kill_stock.length}}</span>
    </div>

    <hr class="details-divider"/>
    
    <!-- Dialog Body -->
    <div class="dialog-body">
        <div class="kill-stock-table-container">
            <table class="kill-stock-table">
                <thead>
                    <tr class="table-header-tr">
                        <th class="table-header">
                            <div class="table-header-name">
                                <span class="header-label">{{ 'quotations_and_orders.copilot_score.kill_stock_details.product' | translate }}</span>
                                <img src="../../../../../assets/icones/include_icon.svg" alt="">
                                <span class="header-label">{{ 'quotations_and_orders.copilot_score.kill_stock_details.order' | translate }}</span>
                            </div>
                        </th>
                        <th class="table-header">
                            <span class="header-label-gray order-value">{{ 'quotations_and_orders.copilot_score.kill_stock_details.order_value' | translate }}</span>
                        </th>
                        <th class="table-header">
                            <span class="header-label">{{ 'quotations_and_orders.copilot_score.kill_stock_details.orders' | translate }}</span>
                        </th>
                        <th class="table-header">
                            <span class="header-label">{{ 'quotations_and_orders.copilot_score.kill_stock_details.stock' | translate }}</span>
                        </th>
                        <th class="table-header">
                            
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let product of data.score.kill_stock">
                        <!-- Product header row -->
                        <tr class="product-header-row">
                            <td class="product-cell">
                                <div class="table-header-name">
                                    <div class="product-image">
                                        <img [src]="product.product_image ? baseUrl + product.product_image + '?thumbnail=1' : placeholder" alt="">
                                    </div>
                                    <div>
                                        <span class="header-label product-name">{{product.product_name}}</span>
                                        <span class="header-label product-sku">{{product | productCode}}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="product-cell">
                                <div class="product-details">
                                </div>
                            </td>
                            <td class="product-cell center-cell">
                                <span class="header-label">{{product.kill_quotes!.length}}</span>
                            </td>
                            <td class="product-cell center-cell">
                                <span class="header-label">{{product.product_stock}}</span>
                            </td>
                            <td class="product-cell center-cell">
                                <img 
                                    src="../../../../../assets/icones/arrow.svg" 
                                    alt=""
                                    class="arrow-icon"
                                    [class.rotated]="isProductExpanded(product.product_id!)"
                                    (click)="toggleProduct(product.product_id!)"
                                >
                            </td>
                        </tr>
                        
                        <!-- Quote rows for this product -->
                        <tr *ngFor="let quote of product.kill_quotes" class="quote-row" [style.display]="isProductExpanded(product.product_id!) ? 'none' : 'table-row'">
                            <td class="quote-cell">
                                <div class="table-header-name">
                                    <img src="../../../../../assets/icones/include_icon.svg" alt="">
                                    <div>
                                        <span class="header-label product-sku">{{quote.name}}</span>
                                        <!-- <span class="header-label">{{quote.product_sku}}</span> -->
                                    </div>
                                </div>
                            </td>
                            <td class="quote-cell center-cell">
                                <div class="quote-score">
                                    <span class="score-value order-value">
                                        {{ quote.amount_total | number:'1.2-2' }} €
                                    </span>
                                </div>
                            </td>
                            <td class="quote-cell center-cell">
                                <span class="header-label final-score">
                                    {{quote.final_score | number:'1.2-2'}} / 100
                                </span>
                            </td>
                            <td class="quote-cell center-cell">
                                <div class="quote-quantity">{{ quote.quantity }}</div>
                            </td>
                            <td class="quote-cell center-cell">
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5" class="alert-cell">
                                <div class="alert_div">
                                    <img src="assets/icones/alert_icon.svg" alt="alert-icon">
                                    <span class="error-message">
                                        {{ 'quotations_and_orders.copilot_score.kill_stock_details.stock_exceeded_message' | translate }}
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <div class="button-group">
            <button class="btn btn-update" (click)="close()">{{ 'common.close' | translate }}</button>
        </div>
    </div>
</div>